import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { MODULE_LIST } from "../apiRoutes";

// Define the expected response type
interface Module {
  moduleId: string;
  moduleName: string;
  description?: string;
  isActive: boolean;
}

interface ModulesResponse {
  data: {
    records: Module[];
    pagination: { totalRecords: number }[];
  }[];
}

const fetchModules = async () => {
  const response = await axiosAuth.get<ModulesResponse>(MODULE_LIST);
  return response.data;
};

export const useGetModulesQuery = (
  queryParams?: UseQueryOptions<ModulesResponse, Error, ModulesResponse, ["modules"]>
) =>
  useQuery<ModulesResponse, Error, ModulesResponse, ["modules"]>({
    queryKey: ["modules"],
    queryFn: fetchModules,
    ...(queryParams as any),
  });
